import React from 'react'
import MuiButton from 'src/components/mui/MuiButton'
import  * as TestService from 'src/services/TestService'
import MainPagePetrolECharts from './MainPagePetrolECharts'

const MainPage = () => {
  return (
    <div>
      <div style={{ display: 'none' }}>
        <MuiButton
          onClick={() => {
            TestService.testGet((resp) => {
              if (resp.success) console.log('btnClick resp ', resp)
            })
          }}
        >
          MainPage test button
        </MuiButton>
      </div>
      <MainPagePetrolECharts />
    </div>
  )
}

export default MainPage
